<template>
  <header id="header">
    <div class="inner_static">
      <a id="btn_back" @click="btnBackClick()"></a>
      <a id="btn_menu" @click="btnMenuClick()">
        <span>
        </span>
      </a>
      <kg-menu
        @menuCloseEvent="menuClose()"
        @toSearchEvent="toSearch()"/>
    </div>
  </header>
</template>

<script>

// kaggul Module
import KgMenu from '../../components/common/KgMenu'

export default {
  components: {
    'kg-menu': KgMenu
  },
  data () {
    return {
      isOpen: false,
      userName: ''
    }
  },
  methods: {
    btnMenuClick: function (event) {
      // メニューを表示する
      if (event) {
        event.preventDefault()
      }
      let scrollpos = 0
      let target = document.getElementById('pnavWrap')
      let bodyElements = document.getElementsByTagName('body')
      if (target.classList.contains('open')) {
        target.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        target.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnBackClick: function () {
      this.$router.push('/kagull/Top')
    },
    menuClose: function () {
      this.btnMenuClick(null)
    },
    toSearch: function () {
      // this.$emit('openSearchBoxEvent')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/mypage/MyPageHeader.vue